import {
  stepTestNameFromMetaRelPath,
  isStepTestMetaRelPath,
} from "../../shared/stepTests/constants";

export function pinnedByExecutionId(
  files: readonly { path: string; content: string }[]
): Map<string, string> {
  const map = new Map<string, string>();
  for (const f of files) {
    if (isStepTestMetaRelPath(f.path)) {
      const name = stepTestNameFromMetaRelPath(f.path);
      const executionId = f.content.trim();
      if (executionId) map.set(executionId, name);
    }
  }
  return map;
}

// Execution ids already pinned as a step test for one step, from a commit's
// full file paths (the Testing tab works with full paths, not step-relative).
export function pinnedExecutionIdsForStep(
  files: readonly { path: string; blob?: { content: string } | null }[],
  stepDir: string
): Set<string> {
  const prefix = `${stepDir}/`;
  const ids = new Set<string>();
  for (const f of files) {
    if (!f.path.startsWith(prefix)) continue;
    if (!isStepTestMetaRelPath(f.path.slice(prefix.length))) continue;
    const executionId = (f.blob?.content ?? "").trim();
    if (executionId) ids.add(executionId);
  }
  return ids;
}
